import { useState, useMemo } from 'react'
import { filterProjects, paginate, calculateTotalPages } from '../home.logic'
import type { Project, StatusFilter } from '../types/home.types'

const PAGE_SIZE = 8

interface UseProjectsFilterResult {
  search: string
  setSearch: (value: string) => void
  statusFilter: StatusFilter
  setStatusFilter: (value: StatusFilter) => void
  currentPage: number
  setCurrentPage: (page: number) => void
  filteredProjects: Project[]
  paginatedProjects: Project[]
  totalPages: number
  totalCount: number
}

export function useProjectsFilter(projects: Project[]): UseProjectsFilterResult {
  const [search, setSearch] = useState('')
  const [statusFilter, setStatusFilter] = useState<StatusFilter>('ทั้งหมด')
  const [currentPage, setCurrentPage] = useState(1)

  const filteredProjects = useMemo(
    () => filterProjects(projects, search, statusFilter),
    [projects, search, statusFilter]
  )

  const totalPages = calculateTotalPages(filteredProjects.length, PAGE_SIZE)

  // Reset to page 1 when filter changes
  const handleSetSearch = (value: string) => {
    setSearch(value)
    setCurrentPage(1)
  }

  const handleSetStatusFilter = (value: StatusFilter) => {
    setStatusFilter(value)
    setCurrentPage(1)
  }

  const paginatedProjects = useMemo(
    () => paginate(filteredProjects, currentPage, PAGE_SIZE),
    [filteredProjects, currentPage]
  )

  return {
    search,
    setSearch: handleSetSearch,
    statusFilter,
    setStatusFilter: handleSetStatusFilter,
    currentPage,
    setCurrentPage,
    filteredProjects,
    paginatedProjects,
    totalPages,
    totalCount: filteredProjects.length,
  }
}
